<template>
  <link id="bootstrap" href="/css/custom.css" rel="stylesheet">

  <NavBarNew :hiddenOption="false"/>

  <loading v-bind:loading="data_.loading" />
  <alert @onFire="eventCloseAlert" v-bind:data_alert="data_alert" />
  <header id="login">

    <div class="container-fluid" v-if="data_.code_temp === ''">
      <div class="row">
        <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-10 mx-auto">

          <div class="card">
            <div class="card-body">
              <h1 class="display-3 mb-3 text-center">Área de clientes</h1>
              <p class="fw-medium mb-2">Inicia sesión</p>




              <form @submit.prevent="submit" class="mb-2" autocomplete="off">

                <div class="form-floating mb-2">
                  <input v-model="data.cif" type="text" class="form-control" id="floatingInput" placeholder="NIF/CIF" required>
                  <label for="floatingInput">NIF/CIF</label>
                </div>
                <div class="form-floating mb-2">
                  <input v-model="data.password" :type="form_.showPass ? 'text' : 'password'" class="form-control" id="floatingPassword" placeholder="Contraseña" required>
                  <label for="floatingPassword">Contraseña</label>
                  <div  @click="showPass()" class="view-pass">
                    <i class="bi bi-eye" v-if="!form_.showPass"></i>
                    <i class="bi bi-eye-slash" v-if="form_.showPass"></i>
                  </div>
                </div>

                <p class="small text-end"><router-link to="recovery">¿Olvidaste tu contraseña?</router-link></p>

                <button class="w-100 btn btn-lg btn-primary mt-4" type="submit">Acceder</button>

              </form>

              <a href="register" class="w-100 btn btn-lg btn-outline-primary">Regístrate</a>

            </div>
          </div>

        </div>

      </div>
    </div>
    <form-code-msg v-if="data_.code_temp !== '' " @onFire="getToken" @onFireCode="submit()" v-model:code_="data_.code_temp" :id="data_login.userId" />
  </header>
  <Footer/>
</template>

<script lang="ts">
import {reactive} from 'vue';
import axios from 'axios'
import * as global from '@/api/global'

import {messageVaidate} from '@/api/utilities'
import Loading from "@/components/Commons/Loading.vue";
import Alert from "@/components/Commons/Alert.vue";
import FormCodeMsg from "@/components/Client/FormCodeMsg.vue";
import Footer from "@/components/Commons/Footer.vue";
import NavBarNew from "@/components/Commons/navBarNew.vue";


export default {
  name: 'Login',
  components: {Loading, Alert, FormCodeMsg, Footer, NavBarNew},
  setup(){

    const data_ = reactive({
      loading: false,
      code_temp: ''
    });

    const data = reactive({
      cif: '',
      password: '',
    });

    const data_login = reactive({
      userId: '',
      code: '',
    });

    const data_alert = reactive({
      title: "",
      msg: "",
      description: "",
      type: "",
      open: false
    })

    const form_ = reactive({
      showPass: false
    });

    const eventCloseAlert = () => {
      data_alert.open=false;
    }

    const submit = async () => {

      data_.loading = true;
      const url =  process.env.VUE_APP_BASE_URL+"/Token/login";

      let response = null
      try {
        response = await axios.post(url, data)
      } catch (e: any) {
        response = e.response || e.request;
      }

      if(response.status== 200){
        data_login.userId = response.data.id;
        data_.code_temp = response.data.authCode.code;


        data_.loading = false;
        //await getToken();
      }else{
        const msg = response.data.title;
        const er = messageVaidate(msg,msg);
        data_.loading = false;
        data_alert.open = true;
        data_alert.type = "danger";
        data_alert.title = "¡Error!";
        data_alert.msg =  "Hubo un problema al tratar de obtener el código sms. Verifique el CIF o la contraseña";
        data_alert.description = response.data ? er.length > 0 ? er[0].traduction_es : msg : "No se pudo establecer conexión";

        window.scrollTo(0, 0);
        await setTimeout(function() {
          data_alert.open = false;
        }, 3000);
      }
    }

    const getToken = async (code: string) => {
      data_login.code = code;
      data_.loading = true;
      const url =  process.env.VUE_APP_BASE_URL+"/Token";
      let response = null
      try {
        response = await axios.post(url, data_login)
      } catch (e: any) {
        response = e.response || e.request;
      }

      if(response.status== 200){
        global.createSession(JSON.stringify(response.data));
        await global.goRoute('/');
      }else{
        const msg = response.data.title;
        const er = messageVaidate(msg);
        data_.loading = false;
        data_alert.open = true;
        data_alert.type = "danger";
        data_alert.title = "¡Error!";
        data_alert.msg = response ? "Hubo un problema al tratar de iniciar sesión." : "No se pudo establecer conexión";
        data_alert.description = response.data ? er.length > 0 ? er[0].traduction_es : msg : "No se pudo establecer conexión";

        window.scrollTo(0, 0);
        await setTimeout(function() {
          data_alert.open = false;
        }, 3000);
      }
    }

    const getPerfilClient = async (clientId: string) => {
      const url =  process.env.VUE_APP_BASE_URL+`/client/${clientId}`;
      let response = null
      try {
        response = await axios.get(url,  {
          headers: {
            Authorization: `Bearer ${global.getToken()}`
          }
        })
      } catch (e: any) {
        response = e.response;
      }

      if(response.status== 200){
        //return response.data.tenant.id === global.getTenantId();
      }else{
        return false
      }
    }

    const showPass = () => {
      form_.showPass = !form_.showPass;
    }

    /* const setTenantData = () => {
      data.tenantId = global.getTenantId();
    }

    setTenantData(); */

    return {
      data,
      data_login,
      data_,
      form_,
      submit,
      eventCloseAlert,
      getToken,
      showPass,
      data_alert,
      getPerfilClient
    }

  },

  beforeUnmount() {
    let styleElement = document.getElementById("bootstrap");

    if (styleElement) {
      let parentElement = styleElement.parentNode;
      if (parentElement) parentElement.removeChild(styleElement);
    }
  },
}
</script>
